import React from 'react';
import { ShieldCheck, Clock, Users, Star, Building2, Stethoscope } from 'lucide-react';

const stats = [
  { icon: <Users size={24} className="text-brand-teal" />, value: '500+', label: 'Pet Owners Served', sub: 'Across Coimbatore' },
  { icon: <Building2 size={24} className="text-brand-orange" />, value: '30+', label: 'Verified Boarding Centres', sub: 'In Coimbatore city' },
  { icon: <Stethoscope size={24} className="text-emergency-red" />, value: '15+', label: 'Licensed Vets Listed', sub: 'Multiple specialities' },
  { icon: <Clock size={24} className="text-purple-500" />, value: '< 5 min', label: 'Avg. Emergency Response', sub: 'Pet owner to vet call' },
  { icon: <Star size={24} className="text-yellow-500" />, value: '4.8 / 5', label: 'Average Platform Rating', sub: 'Across all reviews' },
  { icon: <ShieldCheck size={24} className="text-green-500" />, value: '100%', label: 'Partners Personally Verified', sub: 'Before going live' },
];

const Stats = () => {
  return (
    <section className="py-16 bg-brand-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <p className="text-gray-400 text-sm uppercase tracking-widest font-semibold">PetCares by the Numbers · Coimbatore Launch</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {stats.map((s, i) => (
            <div key={i} className="text-center group">
              <div className="flex justify-center mb-3 group-hover:scale-110 transition-transform">
                {s.icon}
              </div>
              <p className="text-3xl font-extrabold text-white mb-1">{s.value}</p>
              <p className="text-gray-300 text-sm font-semibold">{s.label}</p>
              <p className="text-gray-500 text-xs mt-0.5">{s.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
